var generateComponentTheme = function generateComponentTheme(_ref) {
  var borders = _ref.borders,
    colors = _ref.colors,
    spacing = _ref.spacing;
  return {
    contentWrapperBorderSize: borders.widthSmall,
    contentWrapperBorderColor: colors.tiara,
    contentWrapperBorderRadius: borders.radiusSmall,
    contentWrapperPadding: spacing.small
  };
};
export default generateComponentTheme;